import { Collapse } from "@material-ui/core";
import { useState } from "react";
import { ListarTipoPesoAtendimentoController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { ITipoPesoAtendimento } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoPesoAtendimento/TipoPesoAtendimentoInterfaces";
import OrSpinner from "../../../../../Utils/OrSpinner";
import CreateUpdateTipoPesoAtendimento from "./CretaeUpdateTipoPesoAtendimento";
import ListagemTipoPesoAtendimento from "./ListagemTipoPesoAtendimento";

export default function TipoPesoAtendimento() {
    const {
        loading,
        execute,
        value: lstTipoPesoAtendimento,
    } = useAsyncEffect(ListarTipoPesoAtendimentoController);

    const [editting, setEditting] = useState<ITipoPesoAtendimento>();

    function updateList() {
        execute();
        setEditting(undefined);
    }

    function Edit(toEdit: ITipoPesoAtendimento) {
        if (
            editting?.ID_TIPO_PESO_ATENDIMENTO ===
            toEdit.ID_TIPO_PESO_ATENDIMENTO
        )
            setEditting(undefined);
        else if (!editting) {
            setEditting(toEdit);
        } else {
            setEditting(undefined);
            setTimeout(() => {
                setEditting(toEdit);
            }, 500);
        }
    }

    return (
        <div className="">
            <div className="col-12 collapse mb-5" id="collapseForm">
                <CreateUpdateTipoPesoAtendimento
                    onSave={() => {
                        updateList();
                    }}
                />
            </div>
            <div className="w-100">
                <OrSpinner loading={loading} spinner="capys">
                    {lstTipoPesoAtendimento ? (
                        <ListagemTipoPesoAtendimento
                            lstTipoPesoAtendimento={lstTipoPesoAtendimento}
                            setEdit={Edit}
                            updateList={updateList}
                        />
                    ) : (
                        <div className="text-center text-muted">
                            Erro ao carregar lista de tipo peso atendimento
                        </div>
                    )}
                </OrSpinner>
            </div>
            <Collapse in={!!editting} mountOnEnter unmountOnExit>
                <CreateUpdateTipoPesoAtendimento
                    pesoAtendimento={editting}
                    onSave={() => {
                        updateList();
                    }}
                />
            </Collapse>
        </div>
    );
}
